<div class="kt-form-item">
  @if (label()) {
    <label class="kt-form-label text-gray-900 font-medium" [for]="key">
      {{ label() }}
    </label>
  }

  <div class="kt-form-control">
    <select
      [id]="key"
      appKtSelect
      class="kt-select"
      [ngClass]="getSizeClass()"
      [attr.aria-invalid]="!!errorMessage"
      [attr.data-kt-select]="true"
      [attr.data-kt-select-placeholder]="placeholder()"
      [attr.data-kt-select-disabled]="disabled()"
      [value]="value()"
      [attr.data-kt-select-config]="getSelectConfig()"
      (change)="select($event)"
      (blue)="onTouched()"
    >
      @for (option of options(); track option.value) {
        <option [value]="option.value" [attr.data-kt-select-option]="getOptionExtras(option)">{{ option.label }}</option>
      }
    </select>
  </div>

  @if (description(); as description) {
    <div class="kt-form-description text-gray-900">{{ description }}</div>
  }

  @if (!!errorMessage) {
    <div class="kt-form-message">{{ errorMessage }}</div>
  }
</div>
